jQuery(function() {
    if(jQuery('.js-ds-more-articles').length>0){
        jQuery('.js-ds-more-articles').on('click',function(e){
            e.preventDefault();
            jQuery(this).hide();
            jQuery('div.hide').show();
        })
    }
    if(jQuery('.js-ds-blog-pagination').length>0){
        //console.log("js blog");
        jQuery(".js-ds-blog-pagination").on('click',function(e){
            e.preventDefault();            
            var data_page  = jQuery(this).attr('data-page');
            if(data_page>0){
                page = data_page;
            }else {
                var data_action = jQuery(this).attr('data-action');
                var cur_page = jQuery(".c-pagination__item.is-active a").attr('data-page');
                var num_pages = jQuery(".c-kc-teaser.page").length;
                
                //console.log("num_pages " + num_pages);
                data_action = parseInt(data_action);
                //console.log("cur_page " + cur_page);
                data_action = parseInt(cur_page) + parseInt(data_action);
                //console.log("data_action " + data_action);
                if(data_action>0 && data_action<=num_pages){
                    page = data_action;
                }else {
                    page = cur_page;
                }
                //console.log("page " + page);

            }
            var other_pages = jQuery(".page-"+page).siblings();
            jQuery(other_pages).hide();
            jQuery(".page-"+page).show().css('display','flex');
            jQuery(".c-pagination__item.is-active").removeClass('is-active');
            jQuery('.btn-ds-pagination[data-page='+page+']').closest('div').addClass('is-active');
            jQuery([document.documentElement, document.body]).scrollTop($("#blog-last-news").offset().top - 120);
        }); 
    }
}); 